import React, { useEffect } from "react";
import { Button, List, ListItem, ListItemText, ListItemIcon, IconButton } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { Row, Col } from "react-bootstrap";
import { withRouter } from "react-router";
import { openAlert } from "simple-react-alert";
import { getV2, delV2 } from "../../api/axiosV2";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

const BonificacionesList = (props) => {
  const [bonificaciones, setBonificaciones] = React.useState([]);
  const [pagination, setPagination] = React.useState({
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 0,
  });

  useEffect(() => {
    getBonificaciones(pagination.page, pagination.limit);
  }, []);

  const getBonificaciones = (page, limit) => {
    getV2("/admin/bonificaciones?page=" + page + "&limit=" + limit).then((response) => {
      setBonificaciones(response.data.data);
      setPagination({
        page: response.data.page,
        limit: response.data.limit,
        total: response.data.total,
        totalPages: Math.ceil(response.data.total / response.data.limit),
      });
    });
  };

  const eliminarBonificacion = (id, event) => {
    event.stopPropagation(); // Prevent triggering the list item click
    if (!window.confirm("¿Está seguro que desea eliminar esta bonificación?")) {
      return;
    }

    delV2("/admin/bonificaciones/", id)
      .then(() => {
        openAlert({
          message: "Bonificación eliminada con éxito",
          type: "success",
        });
        // Reload the current page
        getBonificaciones(pagination.page, pagination.limit);
      })
      .catch(() => {
        openAlert({
          message: "Error al eliminar bonificación",
          type: "danger",
        });
      });
  };

  const handleChangePage = (event, value) => {
    setPagination({ ...pagination, page: value });
    getBonificaciones(value, pagination.limit);
  };

  const renderBonificaciones = () => {
    return (
      <List
        component="nav"
        aria-label="main mailbox folders"
        style={{ maxHeight: "400px", overflow: "auto" }}
      >
        {bonificaciones.map((bonificacion, key) => {
          const descuentoDescription = `${
            bonificacion.es_porcentaje ? bonificacion.descuento * 100 : bonificacion.descuento
          }${bonificacion.es_porcentaje ? "%" : "$"}`;
          const extraDescription = bonificacion.negocio
            ? `(${bonificacion.negocio.nombre})`
            : bonificacion.ciudad
            ? `(${bonificacion.ciudad.nombre})`
            : "";
          return (
            <ListItem
              button
              onClick={() => props.history.push("/bonificaciones/editar/" + bonificacion.id)}
              key={key}
            >
              <ListItemText
                primary={`${descuentoDescription} ${extraDescription} - ${bonificacion.razon}`}
              />
              <ListItemIcon>
                <EditIcon />
              </ListItemIcon>
              <IconButton
                edge="end"
                aria-label="delete"
                onClick={(e) => eliminarBonificacion(bonificacion.id, e)}
                color="secondary"
              >
                <DeleteIcon />
              </IconButton>
            </ListItem>
          );
        })}
      </List>
    );
  };

  return (
    <Row xs={{ span: 12, offset: 2 }} className="justify-content-md-center rowContainer">
      <Col xs={8}>
        <Button
          size="large"
          variant="contained"
          className="ml-2"
          onClick={() => props.history.push("/bonificaciones/nuevo")}
        >
          Agregar nueva bonificación
        </Button>
        {renderBonificaciones()}
        <Pagination
          count={pagination.totalPages}
          color="primary"
          onChange={handleChangePage}
          page={pagination.page}
          className="mt-2"
        />
      </Col>
    </Row>
  );
};

export default withRouter(BonificacionesList);
